import { create } from 'zustand';
import _cloneDeep from 'lodash/cloneDeep';

interface BannerInfoValues {
  bannerID: number;
  banner: string;
  isBannerOn: boolean;
  version: string;
}
interface DeveloperStoreValues {
  bannerInfo: BannerInfoValues;
  isUrlReachable?: boolean;
}

interface DeveloperState extends DeveloperStoreValues {
  resetToDefaults: () => void;
  setBannerInfo: (bannerInfo: BannerInfoValues) => void;
  setIsUrlReachable: (isUrlReachable: boolean) => void;
}

const defaults: DeveloperStoreValues = {
  bannerInfo: {
    bannerID: 0,
    banner: '',
    isBannerOn: false,
    version: '0.0.0',
  },
  isUrlReachable: undefined,
};

export const useDeveloperStore = create<DeveloperState>((set) => ({
  ..._cloneDeep(defaults),
  resetToDefaults: () => set(_cloneDeep(defaults)),
  setBannerInfo: (bannerInfo) => set({ bannerInfo }),
  setIsUrlReachable: (isUrlReachable) => set({ isUrlReachable }),
}));
